module.exports = __webpack_public_path__ + "static/media/Ellipse 1.6de7b101.png";